<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <KTCodePreview v-bind:title="'Perfis Cadastrados'">
          <template v-slot:preview>
            <v-row v-if="processando" class="mb-5">
              <v-col cols="12">
                <v-progress-linear
                  indeterminate
                  color="indigo"
                ></v-progress-linear>
              </v-col>
            </v-row>
            <v-row class="mb-5">
              <v-col align-self="start">
                <v-btn
                  v-if="verificarPermissao(permissoesPadrao.Incluir)"
                  color="primary"
                  fab
                  x-small
                  dark
                  @click="novo()"
                  ><v-icon>mdi-plus</v-icon></v-btn
                >
              </v-col>
              <v-col cols="2" align-self="end">
                <v-switch @change="listarPerfis()" v-model="listarInativos">
                  <template #label> Ver Inativos </template>
                </v-switch>
              </v-col>
            </v-row>
            <v-data-table
              :headers="headers"
              :items="perfis"
              :items-per-page.sync="itemsPerPage"
              :page.sync="page"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.id }}</td>
                  <td>{{ item.nome }}</td>
                  <td>{{ item.administrador ? "Sim" : "Não" }}</td>
                  <td align="center">
                    <v-btn
                      v-if="verificarPermissao(permissoesPadrao.Editar)"
                      color="warning"
                      fab
                      x-small
                      dark
                      @click="editar(item.id)"
                      :disabled="!item.ativo"
                      ><v-icon>mdi-pencil</v-icon></v-btn
                    >
                    <v-btn
                      color="error"
                      v-if="verificarPermissao(permissoesPadrao.Excluir)"
                      fab
                      x-small
                      dark
                      @click="inativar(item.id)"
                      class="ml-2"
                      :disabled="!item.ativo"
                      ><v-icon>mdi-trash-can</v-icon></v-btn
                    >
                    <v-btn
                      color="success"
                      v-if="verificarPermissao(permissoesPadrao.Incluir)"
                      fab
                      x-small
                      dark
                      @click="ativar(item.id)"
                      :disabled="item.ativo"
                      class="ml-2"
                      ><v-icon>fas fa-lock-open</v-icon></v-btn
                    >
                  </td>
                </tr>
              </template>
            </v-data-table>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from "@/views/partials/content/CodePreview.vue";
import ApiService from "@/common/services/http/api.service";
import SweetAlert from "@/common/services/sweetalert.service";
import Permissoes from "@/common/services/permissoes/permissoes.js";
import Modulo from "@/common/services/permissoes/modulos.js";
import PermissoesService from "@/common/services/permissoes/permissoes.service.js";
import { SET_LOADING } from "@/store/config.module";

export default {
  data: () => ({
    perfis: [],
    page: 1,
    cliente: {},
    itemsPerPage: 10,
    permissoesPadrao: {},
    processando: false,
    listarInativos: false,
    headers: [
      { text: "ID", value: "id" },
      { text: "Nome", value: "nome" },
      { text: "Administrador", value: "administrador" },
      { text: "", value: "" },
    ],
  }),
  components: {
    KTCodePreview,
  },
  methods: {
    verificarPermissao(permissao) {
      return PermissoesService.verificarAcesso(Modulo.Perfil, permissao);
    },
    async listarPerfis() {
      this.processando = true;
      try {
        const { data: result } = await ApiService.get(
          `perfil/listar/cliente/${this.cliente.id}`,
          "",
          {
            listarInativos: this.listarInativos,
          }
        );
        if (result.success) this.perfis = result.data;

        this.processando = false;
        this.$store.commit(SET_LOADING, false);
      } catch (error) {
        this.processando = false;
      }
    },
    async inativar(id) {
      this.processando = true;
      try {
        const { data: result } = await ApiService.delete(`perfil/${id}`);
        if (result.success) {
          SweetAlert.sweetAlertSuccess("Registro Excluído com sucesso!");
        } else {
          SweetAlert.sweetAlertError(result.errors);
        }
        this.processando = false;
      } catch (error) {
        this.processando = false;
      }
      await this.listarPerfis();
    },

    async ativar(id) {
      this.processando = true;
      try {
        const { data: result } = await ApiService.put(`perfil/ativar/${id}`);
        if (result.success) {
          SweetAlert.sweetAlertSuccess("Registro Recuperado com sucesso!");
        } else {
          SweetAlert.sweetAlertError(result.errors);
        }
        this.processando = false;
      } catch (error) {
        this.processando = false;
      }
      await this.listarPerfis();
    },
    editar(id) {
      this.$router.push({ path: "perfil/cadastro/" + id });
    },
    novo() {
      this.$router.push({ path: "perfil/cadastro/" });
    },
  },
  async mounted() {
    this.$store.dispatch(SET_LOADING, true);
    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));
    this.permissoesPadrao = Permissoes;
    await this.listarPerfis();
  },
  created() {
    if (
      !PermissoesService.verificarAcesso(Modulo.Perfil, Permissoes.Visualizar)
    ) {
      SweetAlert.sweetAlertError([
        "Você não tem permissão para acessar essa parte do sistema",
      ]);
      this.$router.push({ name: "index" });
    }
  },
};
</script>
<style lang="scss"></style>
